import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "nes-container with-title mb-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Welcome", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Welcome to Gem Farm 💎 - the #1 NFT Staking solution on Solana!", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, " This front-end is primarily designed for the Farm Manager (most likely the dev behind the NFT project). You probably want to build a nicer front-end for your stakers (farmers 👩‍🌾). ", -1)
const _hoisted_5 = { class: "mt-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" That said, if you're a staker, in theory nothing is stopping you from using this front-end to access ALL the farms you're staking with. Simply go to the ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("farmer")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" tab and enter the farm address (ask your NFT project for it). ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, [
  /*#__PURE__*/_createTextVNode(" You can find the docs "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "text-blue-600",
    href: "https://docs.gemworks.gg/",
    target: "_blank"
  }, "here"),
  /*#__PURE__*/_createTextVNode(". ")
], -1)
const _hoisted_10 = { class: "mt-5" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Gem Farm is deployed at: ")
const _hoisted_12 = { class: "bg-yellow-100" }
const _hoisted_13 = { class: "flex flex-row" }
const _hoisted_14 = { class: "nes-container with-title flex-1 mr-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Start/manage a farm", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " Choose this if you have your own NFT collection you'd like to offer staking for. ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary" }, "Start a farm", -1)
const _hoisted_18 = { class: "nes-container with-title flex-1 ml-5" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Stake your NFTs", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "mb-5" }, " Choose this if you'd like to stake your NFTs at one of the existing farms. ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", { class: "nes-btn is-primary" }, "Stake NFTs", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_router_link, {
          to: "/farmer",
          class: "text-blue-700"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8
      ]),
      _hoisted_9,
      _createElementVNode("p", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.GEM_FARM_PROG_ID), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _hoisted_16,
        _createVNode(_component_router_link, { to: "manager" }, {
          default: _withCtx(() => [
            _hoisted_17
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _hoisted_20,
        _createVNode(_component_router_link, { to: "farmer" }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}